import React from 'react';
import ItemCard from '@web-mail/components/ItemCard';
import styles from './MemberRow.module.scss';
const MemberRow = ({ member, contactModel }) => {
    const content = (React.createElement("div", { className: styles.memberRow },
        React.createElement("span", { className: styles.name }, member.name),
        React.createElement("span", { className: styles.email }, member.email)));
    if (contactModel) {
        return (React.createElement(ItemCard, { placement: "rightTop", contact: contactModel, trigger: "click", domName: "body" }, content));
    }
    return content;
};
export default MemberRow;
